<template>
  <div class="container" style="background-color: #FFFFFF;">
    <div class="head">
      <div class="head__fixed">
        <div class="head__fixed__box">
          <div class="header__fixed__left"><a href="javascript:history.go(-1)" class="back"></a></div>
          <div class="header__fixed__center">
            <h1>优惠活动专区</h1>
          </div>
          <div class="header__fixed__right"></div>
        </div>
      </div>
    </div>
    <div class="huo">
      <div @click="toBuyCardGetCoupon()" class="huodong"></div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {

      }
    },
    created() { },
    watch: { },
    mounted() { },
    methods: {
     toBuyCardGetCoupon(){
       this.$router.push({
         name:'buycardgetcoupon'
       })
     }
    }
  }
</script>

<style lang="less" scoped="scoped">
  @vm_base: 1/750*100vw;
  .huo{
    position: relative;
    width: 100%;
    height: calc(100vh - 90*@vm_base);
    background-color: #FFFFFF;
    overflow: hidden;
    .huodong{
      margin-top: 60*@vm_base;
      margin-left: 60*@vm_base;
      width: 630*@vm_base;
      height: 314*@vm_base;
      background-size: cover;
      background-image: url(../../../assets/images/base/vipc.png);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/discount/activity/list.vue